
import { defineComponent } from 'vue'
import { useStore } from 'vuex'
import { isNativeApp, isIframe, isMiniProgramPromise } from '@remote/utils'
import { AuthorizeLogout } from '@remote/constant'

export default defineComponent({
  setup () {
    const store = useStore()
    let isApp = false
    if (isNativeApp() || isIframe()) {
      // 在厂商app、iframe
      isApp = true
      console.log('postMessage,', '退出成功')
      window.parent.postMessage(AuthorizeLogout,'*')
    }
    return { isApp, store }
  },
  async mounted () {
    // TODO: 在setup里获取到的isMiniProgram不准确(可能getEnv异步的)
    const isMiniProgram = await isMiniProgramPromise()
    if (isMiniProgram || this.isApp) {
      this.store.dispatch('close')
    } else {
      location.href = location.href.replace('/close', '/login')
    }
  },
})
